// import { Button, Divider, Grid, IconButton, Typography } from "@mui/material";
// import React, { useState } from "react";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import WSSelectField from "../../Components/Select/WSSelect";
// import { useForm, useFormContext } from "react-hook-form";
// import {
//   customValidation,
//   validations,
// } from "../../commonFunctions/CommonFunctions";
// import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
// import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
// import { WSIcons } from "../../commonFunctions/iIcons";
// import config from "../../Config/clientConfig.json"
// export const GstAddress: React.FC<any> = React.memo((props) => {
//   const { control, register } = useForm();
//   const [showShipping, setShowShipping] = useState(false);

//   const handleEnableShipping = () => {
//     setShowShipping(true);
//   };

//   return (
//     <Grid container spacing={2} alignItems="flex-start">
//       {/* Left Section */}
//       <Grid item xs={12} md={5}>
//         <Grid container direction="column" spacing={2}>
//           <Grid item>
//             <WSSelectField
//               rules={{ required: false }}
//               {...register("gstType")}
//               id="gstType"
//               control={control}
//               defaultValue={"0"}
//               label="GST Type"
//               name="gstType"
//               options={config.gstTypeconfig.staticOptionData}
//             />
//           </Grid>
//           <Grid item>
//             <WSSelectField
//               rules={{ required: false }}
//               {...register("state")}
//               id="state"
//               control={control}
//               defaultValue={"0"}
//               label="State"
//               name="state"
//               options={config.stateConfig.staticOptionData}
//             />
//           </Grid>
//           <Grid item>
//             <WSTextField
//               className="form-control"
//               id="email"
//               type={TextType.Text}
//               rules={customValidation(false, validations.email)}
//               {...register("email")}
//               label="Email"
//               control={control}
//             />
//           </Grid>
//         </Grid>
//       </Grid>

//       {/* Right Section */}
//       <Grid item xs={12} md={6}>
//         <Grid container direction="column" spacing={2}>
//           <Grid item>
//             <WSTextAreaField
//               label={"Billing Address"}
//               id={"billingAddress"}
//               name={"billingAddress"}
//               control={control}
//               rules={{ required: false }}
//               rows={3}
//             />
//           </Grid>
//           {!showShipping && (
//             <Grid item>
//               <Button
//                 variant="text"
//                 size="small"
//                 sx={{ textTransform: "none", p: 0, mt: 1 }}
//                 onClick={handleEnableShipping}
//               >
//                 + Enable Shipping Address
//               </Button>
//             </Grid>
//           )}

//           {/* Shipping Address Field */}
//           {showShipping && (
//             <Grid item>
//               <WSTextAreaField
//                 label="Shipping Address"
//                 id="shippingAddress"
//                 name="shippingAddress"
//                 control={control}
//                 rules={{ required: false }}
//                 rows={3}
//               />
//             </Grid>
//           )}
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// });



import { Grid } from "@mui/material";
import React, { useState } from "react";
import WSSelectField from "../../Components/Select/WSSelect";
import { useFormContext } from "react-hook-form";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import { customValidation, validations } from "../../commonFunctions/CommonFunctions";
import config from "../../Config/clientConfig.json";
import Button from "@mui/material/Button";

export const GstAddress: React.FC = React.memo(() => {
  const { control, register } = useFormContext();
  const [showShipping, setShowShipping] = useState(false);

  const handleEnableShipping = () => setShowShipping(true);

  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid item xs={12} md={5}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <WSSelectField
              rules={{ required: false }}
              {...register("gstType")}
              id="gstType"
              control={control}
              defaultValue="0"
              label="GST Type"
              name="gstType"
              options={config.gstTypeconfig.staticOptionData}
            />
          </Grid>
          <Grid item>
            <WSSelectField
              rules={{ required: false }}
              {...register("state")}
              id="state"
              control={control}
              defaultValue="0"
              label="State"
              name="state"
              options={config.stateConfig.staticOptionData}
            />
          </Grid>
          <Grid item>
            <WSTextField
              className="form-control"
              id="email"
              type={TextType.Text}
              rules={customValidation(false, validations.email)}
              {...register("email")}
              label="Email"
              control={control}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <WSTextAreaField
              label="Billing Address"
              id="billingAddress"
              name="billingAddress"
              control={control}
              rules={{ required: false }}
              rows={3}
            />
          </Grid>
          {!showShipping && (
            <Grid item>
              <Button
                variant="text"
                size="small"
                sx={{ textTransform: "none", p: 0, mt: 1 }}
                onClick={handleEnableShipping}
              >
                + Enable Shipping Address
              </Button>
            </Grid>
          )}
          {showShipping && (
            <Grid item>
              <WSTextAreaField
                label="Shipping Address"
                id="shippingAddress"
                name="shippingAddress"
                control={control}
                rules={{ required: false }}
                rows={3}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
});
